/* Newsletter-Anmeldung direkt an Klaviyo (Client-API, Liste per data-Attribut).
   Ohne JS oder ohne Klaviyo-Konfiguration fällt das Formular auf das
   Shopify-Kundenformular zurück. */
(function () {
  var REVISION = '2025-07-15';

  function init(wrapper) {
    var form = wrapper.querySelector('form');
    var companyId = wrapper.getAttribute('data-klaviyo-company');
    var listId = wrapper.getAttribute('data-klaviyo-list');
    if (!form || !companyId || !listId || !window.fetch) return;

    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var field = form.querySelector('.newsletter-strip__field');
    var success = form.querySelector('[data-newsletter-success]');
    var error = form.querySelector('[data-newsletter-error]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = (input.value || '').trim();
      if (!email) {
        input.focus();
        return;
      }

      button.disabled = true;
      form.classList.add('is-loading');
      if (error) error.hidden = true;

      fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: REVISION
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: wrapper.getAttribute('data-klaviyo-source') || 'Website Newsletter',
                profile: { data: { type: 'profile', attributes: { email: email } } }
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        }
      )
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo: HTTP ' + response.status);
          form.classList.add('is-success');
          if (field) field.hidden = true;
          if (success) {
            success.hidden = false;
            success.focus();
          }
        })
        .catch(function () {
          if (error) error.hidden = false;
        })
        .finally(function () {
          button.disabled = false;
          form.classList.remove('is-loading');
        });
    });
  }

  document.querySelectorAll('[data-klaviyo-list]').forEach(init);
})();
